import { HttpClient } from '@angular/common/http';
import BigNumber from 'bignumber.js';
import { tap } from 'rxjs/operators';
import { Base } from '../../base';

export class Funds extends Base {
  constructor(protected httpClient: HttpClient, private parent: string) {
    super(httpClient, `${parent}/funds`);
  }

  query(params?: any) {
    return this.api.query(params).pipe(
      tap((json) => json.funds.forEach((record: any) => this.processRecord(record)))
    )
  }

  private processRecord(record: any) {
    record.amount = new BigNumber(record.amount).fromDecimal();
  }
}
